import { FunctionComponent } from 'react'
import { useSelector } from 'react-redux'

import { lazyRenderWidget } from 'core-components/helpers/lazyLoad'
import { useInitPage } from 'core-components/sitebuilder/layout/hooks/useInit'
import { useLayoutConfig } from 'core-components/sitebuilder/layout/hooks/useLayoutConfig'
import { IBaseLayout } from 'core-components/sitebuilder/models/IBaseLayout'
import { selectSitePages } from 'core-components/sitebuilder/store/selectors/selectSitePages'

export interface ILayoutSelectorProps extends IBaseLayout {
  pageId?: string
  EmptyLayout: FunctionComponent
}

export const LayoutSelector = (props: ILayoutSelectorProps) => {
  const sitePages = useSelector(selectSitePages)
  const { EmptyLayout } = props
  const sitePage = sitePages.find((i) => i.id === props.pageId)
  const { isInit } = useInitPage({ id: props.pageId })

  const layoutSettings = useLayoutConfig({ id: sitePage?.layoutUser })
  const layoutProps = sitePage?.layoutUserSettings || {}

  const defaultSettings = useLayoutConfig({ id: 'default' })

  if (!isInit) {
    return <div>Wait initialization...</div>
  }

  if (layoutSettings) {
    return lazyRenderWidget(layoutSettings.template, { ...props, ...layoutProps })
  }

  if (defaultSettings) {
    return lazyRenderWidget(defaultSettings.template, { ...props, ...layoutProps })
  }

  return <EmptyLayout />
}
